import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';

export const PipelineStageSummary = ({ formatCurrency, getDealsForStage, pipelineStages, stats }) => (
      <Card>
        <CardHeader className="px-3 sm:px-4 md:px-6">
          <CardTitle className="text-base sm:text-lg">Stage Summary</CardTitle>
        </CardHeader>
        <CardContent className="px-2 sm:px-4 md:px-6">
          <div className="overflow-x-auto -mx-2 sm:mx-0">
            <table className="w-full text-xs sm:text-sm min-w-[400px]">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-2 px-2 sm:px-3 font-medium text-gray-500">Stage</th>
                  <th className="text-center py-2 px-2 sm:px-3 font-medium text-gray-500">Count</th>
                  <th className="text-right py-2 px-2 sm:px-3 font-medium text-gray-500">Value</th>
                  <th className="text-right py-2 px-2 sm:px-3 font-medium text-gray-500 hidden sm:table-cell">% of Total</th>
                </tr>
              </thead>
              <tbody>
                {pipelineStages.map((stage, index) => {
                  const count = stats.byStage[stage.id] || 0;
                  const stageDeals = getDealsForStage(stage.id);
                  const stageValue = stageDeals.reduce((sum, d) => sum + (d.Amount || 0), 0);
                  const StageIcon = stage.icon;
                  
                  return (
                    <tr key={stage.id} className="border-b hover:bg-gray-50 dark:hover:bg-gray-800">
                      <td className="py-1.5 sm:py-2 px-2 sm:px-3">
                        <div className="flex items-center gap-1.5 sm:gap-2">
                          <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full ${stage.color} flex items-center justify-center flex-shrink-0`}>
                            <StageIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-white" />
                          </div>
                          <span className="font-medium text-xs sm:text-sm truncate max-w-[100px] sm:max-w-none">{stage.label}</span>
                        </div>
                      </td>
                      <td className="text-center py-1.5 sm:py-2 px-2 sm:px-3">
                        <Badge variant="outline" className="text-xs">{count}</Badge>
                      </td>
                      <td className="text-right py-1.5 sm:py-2 px-2 sm:px-3 font-medium text-xs sm:text-sm">
                        {formatCurrency(stageValue)}
                      </td>
                      <td className="text-right py-1.5 sm:py-2 px-2 sm:px-3 text-gray-500 hidden sm:table-cell">
                        {stats.value > 0 ? ((stageValue / stats.value) * 100).toFixed(1) : 0}%
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
);
